import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkGetMonthlyTotals } from '../types';

const onGetMonthlyTotals: IThunkGetMonthlyTotals = thunk(async (_, { signal, ...request }) =>
  api.communityEngagement.getMonthlyRecord(request, signal).then(response => response.data),
);

export default onGetMonthlyTotals;
